var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 39,
    viewBox: "0 0 50 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2941 17.6602C36.1063 17.6602 36.7647 17.0013 36.7647 16.1885C36.7647 15.3757 36.1063 14.7168 35.2941 14.7168C34.482 14.7168 33.8235 15.3757 33.8235 16.1885C33.8235 17.0013 34.482 17.6602 35.2941 17.6602Z",
    fill: "#FF7403"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5806 8.125H30.6451",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5484 1.625H29.0323",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61292 22.75C1.61292 20.0586 3.78025 17.875 6.45162 17.875",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4234 13H45.1613C46.9435 13 48.3871 14.4544 48.3871 16.25V22.75C48.3871 24.5456 46.9435 26 45.1613 26H43.5484L39.8992 36.2964C39.6693 36.9444 39.0605 37.375 38.379 37.375H35.8145C35.1331 37.375 34.5242 36.9444 34.2944 36.2964L33.5262 34.125H19.6996L18.9314 36.2964C18.7016 36.9444 18.0927 37.375 17.4113 37.375H14.8468C14.1653 37.375 13.5564 36.9444 13.3266 36.2964L10.6855 28.8438C7.95766 25.8517 6.44757 21.9375 6.45161 17.875C6.45161 8.90094 13.6734 1.625 22.5806 1.625H29.0323C35.4657 1.625 41.2843 5.47219 43.8387 11.4197C44.0605 11.9356 44.254 12.4637 44.4234 13Z",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyIcon4);
export default __webpack_public_path__ + "static/media/why_icon4.918d60f49a2401d41808090b188b6649.svg";
export { ForwardRef as ReactComponent };